import { combineReducers } from 'redux'
import listReducer, { listActions } from '@app-store/slices/templates/list'
import staticEnumsReducer, { staticEnumsActions } from '@app-store/slices/templates/staticEnums'
import createTemplateReducer, { createTemplateActions } from './create'
import editTemplateReducer, { editTemplateActions } from './edit'
import oneTemplateReducer, { oneTemplateActions } from './oneTemplate'

export const templateReducers = combineReducers({
    list: listReducer,
    staticEnums: staticEnumsReducer,
    create: createTemplateReducer,
    edit: editTemplateReducer,
    one: oneTemplateReducer
})

export const templateActions = {
    list: listActions,
    staticEnums: staticEnumsActions,
    create: createTemplateActions,
    edit: editTemplateActions,
    one: oneTemplateActions
}
